import { render } from "./editScoringTableCertificationsModal.vue?vue&type=template&id=1f8f2877&scoped=true&ts=true"
import script from "./editScoringTableCertificationsModal.vue?vue&type=script&lang=ts"
export * from "./editScoringTableCertificationsModal.vue?vue&type=script&lang=ts"

import "./editScoringTableCertificationsModal.vue?vue&type=style&index=0&id=1f8f2877&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f8f2877"]])

export default __exports__